import { render, staticRenderFns } from "./SearchResultsLock.vue?vue&type=template&id=3b4a0066&scoped=true&"
import script from "./SearchResultsLock.vue?vue&type=script&lang=js&"
export * from "./SearchResultsLock.vue?vue&type=script&lang=js&"
import style0 from "./SearchResultsLock.vue?vue&type=style&index=0&id=3b4a0066&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4a0066",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
